module.exports = __webpack_public_path__ + "static/media/pdf.27b19623.svg";